
import { JsonServiceClient } from "@servicestack/client";

import { IAlert } from '@/contexts/data/AlertContext';
import { AlertTitle } from "@mui/material";


export const DefaultClient = (baseUrl?: string, basePath?: string, onAlert?: (alert: IAlert) => void) => {

    const client = new JsonServiceClient(baseUrl)
    .apply(c => {
        c.basePath = basePath ?? null;
        c.headers = new Headers() //avoid pre-flight CORS requests
    });

    client.exceptionFilter = (res: Response, error: any) => {
        const msg = error.responseStatus.message ?? "Something went wrong";

        if (msg === 'Not Authenticated') {
            window.location.href = `/auth/openiddict?redirect=${encodeURIComponent(global.location.pathname + global.location.search)}`;
        } else {
            onAlert && onAlert({
                content: <AlertTitle>
                    {msg}
                </AlertTitle>,
                timeout: 5000,
                severity: "error",
                dismissable: true,
            });
        }
    };

    return client;
}

export default DefaultClient;